import { PropTypes } from "base/react-libs";
import { useIdentity } from "base/identity-resolver";
import { useState, useEffect } from "react";
import { moveConstituentToJourney } from "apps/journeys/utils/api-requests/modal-actions";
import { fetchAllJourneysForAllJourneyGroups } from "apps/journeys/utils/api-requests/journey-index";
import { Modal, ModalHeaderWithActions, ModalBody, ListboxSelect } from "@evertrue/et-components";
import FormField from "components/forms/form-field";
import TaskRowDetailsContactCard from "../detail/task-table/task-row/task-row-details-contact-card";

const EndJourneyModal = ({ isOpen, onClose, task = {}, step = {}, completeTaskStateUpdates, currentJourney }) => {
  const { contact } = task;
  const { user, org } = useIdentity();
  const [journeyOptions, setJourneyOptions] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const getAndSetJourneyOptions = async () => {
      const journeys = await fetchAllJourneysForAllJourneyGroups();
      setJourneyOptions(
        journeys
          .filter((j) => j.name !== currentJourney.name)
          .map((j) => {
            return { label: j.name, value: j.id, id: j.id };
          })
      );
    };

    if (isOpen) getAndSetJourneyOptions();
  }, [currentJourney, isOpen]);

  const handleSubmit = async () => {
    if (selected && selected.value) {
      await completeTaskStateUpdates(task, step);
      await moveConstituentToJourney(currentJourney.id, contact.id, user.id, org.id, selected.id, selected.label);
    }
    onClose();
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <ModalHeaderWithActions
        title={"End of Cadence"}
        closeModal={onClose}
        onSubmit={handleSubmit}
        submitLabel="Done"
        disableSubmit={!selected}
      />
      <ModalBody scrollable={false}>
        <p className="journey-modal--warning">
          To complete this last step of the cadence, please select the next cadence to move this constituent into.
        </p>

        <TaskRowDetailsContactCard contact={contact} avatarSize={60} />
        <div className="end-journey-form-field">
          <FormField label="Current Cadence" boldLabel={true} inlineLabel={false}>
            {currentJourney.name}
          </FormField>
          <FormField label="Current Task" boldLabel={true} inlineLabel={false} className="end-journey-current-task">
            <div>{`Step ${step.step_number}| Day ${step.day_number}`}</div>
            <div>{step.task_template.title}</div>
          </FormField>
        </div>

        <FormField label="This constituent will be moved to:" boldLabel={true} inlineLabel={false}>
          <div className="end-journey-listboxselect">
            <ListboxSelect
              options={journeyOptions}
              size="medium"
              onChange={(val) => {
                setSelected(val);
              }}
              value={selected}
              label="Select Cadence"
              emptyValue="Select Cadence"
            />
          </div>
        </FormField>
      </ModalBody>
    </Modal>
  );
};

EndJourneyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object,
  step: PropTypes.object,
  completeTaskStateUpdates: PropTypes.func,
  currentJourney: PropTypes.object,
};

export default EndJourneyModal;
